import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
// import { REPORT } from './components';

const REPORT = lazy(()=> import(/* webpackChunkName: "mainroutes" */ './components/Report'))

const routes = () => (
  <PrivateRoute exact path="/billing" component={REPORT} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/reporting/Billing/routes.js